
import React from 'react';

const variants = {
  primary: 'bg-accent text-accent-foreground hover:bg-accent-hover disabled:opacity-50',
  secondary: 'bg-muted text-muted-foreground hover:bg-border disabled:opacity-50',
  ghost: 'hover:bg-muted hover:text-foreground',
  destructive: 'bg-red-500 text-white hover:bg-red-600',
};

const sizes = {
  sm: 'h-9 px-3 rounded-md',
  md: 'h-10 px-4 py-2 rounded-lg',
  lg: 'h-11 px-8 rounded-lg text-base',
  icon: 'h-10 w-10',
};

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: keyof typeof variants;
  size?: keyof typeof sizes;
  children: React.ReactNode;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'primary', size = 'md', children, ...props }, ref) => {
    return (
      <button
        className={`inline-flex items-center justify-center font-semibold tracking-wide ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none ${variants[variant]} ${sizes[size]} ${className}`}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = 'Button';

export { Button };
